var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumbs my-3 md:my-0"},[_c('p',[_vm._l((_vm.breadCrumbs),function(breadCrumb,index){return _c('span',{key:breadCrumb.index},[_c('router-link',{attrs:{"to":`/${_vm.$i18n.locale}${breadCrumb.path}`}},[_vm._v(" "+_vm._s(breadCrumb.title)+" ")]),(
          index < _vm.breadCrumbs.length - 1 ||
          (index < _vm.breadCrumbs.length && _vm.currentpage)
        )?_c('span',{staticClass:"seperator"},[_vm._v("  "),_c('icon-chevron-right')],1):_vm._e()],1)}),_c('span',{staticClass:"text-black font-bold"},[_vm._v(_vm._s(_vm.currentpage))])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }